import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { EmbedAuthService } from '../services/auth/embed-auth.service';
import { UrlConstants } from '../constants/url.constants';

@Injectable({
  providedIn: 'root'
})
class CanActivateEmbedGuard {
  constructor(private embedAuthService: EmbedAuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authToken = route.queryParamMap.get('authToken');
    const isPayerCredential =
      route.queryParamMap.get('isPayerCredential') === 'true' ? true : false;
    return this.embedAuthService
      .isAuthenticated(authToken, isPayerCredential)
      .pipe(
        map((response) =>
          response ? true : this.router.createUrlTree([UrlConstants.embedSessionInvalidUrl])
        )
      );
  }
}

export const canActivateEmbed: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const guard = inject(CanActivateEmbedGuard);
  return guard.canActivate(route);
};
